/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import { BoldButton } from '@bold/web-components-react';
import { StaticImage } from 'gatsby-plugin-image';
import COMPANY_INFO from 'constants/company-info';
import IRight from 'assets/images/global/svg/ic_chevron_right_w.inline.svg';
import IPlay from 'assets/images/global/svg/play.inline.svg';
import SegmentButton from 'components/website/SegmentButton';

const SlideNairo = ({ size, height, handleModal }) => {
  const [image, setImage] = useState();

  useEffect(() => {
    const QUERY = {
      sm: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-nairo-sm.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
      md: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-nairo-md.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
      xx: (
        <StaticImage
          className="hero-main-image"
          src="./images/banner-nairo-xx.jpg"
          alt="Bold"
          loading="eager"
          fetchpriority="high"
        />
      ),
    };

    setImage(QUERY[size]);
  }, [size]);

  const goToSupportURL = whatsAppOptions => {
    const whatsAppURL = `/whatsapp?${Object.keys(whatsAppOptions)
      .map(key => `${key}=${encodeURIComponent(whatsAppOptions[key])}`)
      .join('&')}`;

    window.open(whatsAppURL, '_blank', 'noopener noreferrer');
  };

  const handleSalesSupport = e => {
    e.preventDefault();

    const whatsAppOptions = {
      subject: 'sales',
      from: 'float_button',
      phone: 'default',
      text: '¡Hola! me interesa el datáfono Bold Plus, ¿Pueden darme más información?',
    };

    goToSupportURL(whatsAppOptions);
  };

  return (
    <>
      <div className="hero-slider-container overlay nairo" style={{ height }}>
        {image}

        <div className="content-slider">
          <div className="info-center">
            <div className="show-mobile">
              <div>
                <h1>
                  Recibe más tarjetas, <br />
                  pedalea por tu negocio.
                </h1>
                <p className="banner-paragraph">¡Descubre cómo Nairo pedalea por sus sueños!</p>
                <p className="link-modal" onClick={handleModal} type="button">
                  Ver video <IPlay />
                </p>
              </div>
            </div>
            <div className="show-tablet">
              <div>
                <h1>
                  Recibe más tarjetas, <br />
                  pedalea por tu <br /> negocio.
                </h1>
                <p className="banner-paragraph">¡Descubre cómo Nairo pedalea por sus sueños!</p>
                <p className="link-modal" onClick={handleModal} type="button">
                  Ver video <IPlay />
                </p>
              </div>
            </div>
            <div className="show-desktop">
              <div>
                <h1>
                  Recibe más tarjetas, <br />
                  pedalea por tu <br /> negocio.
                </h1>
                <p className="banner-paragraph">¡Descubre cómo Nairo pedalea por sus sueños!</p>
                <p className="link-modal" onClick={handleModal} type="button">
                  Ver video <IPlay />
                </p>
              </div>
            </div>

            <div className="button-wrapper">
              <SegmentButton
                event="purchase"
                url={COMPANY_INFO.STORE}
                isLink
                isBlank
                obj={{
                  page_section: 'old_hero',
                  banner_name: 'nairo',
                }}
              >
                <BoldButton className="hero-btn" size="full" color="accent" type="button">
                  Comprar mi datáfono
                  <IRight slot="end" alt="Bold" />
                </BoldButton>
              </SegmentButton>
              <SegmentButton
                event="contactsales"
                obj={{
                  page_section: 'old_hero',
                  banner_name: 'nairo',
                }}
              >
                <BoldButton
                  className="hero-btn"
                  size="full"
                  outlined
                  color="accent"
                  type="button"
                  onClick={handleSalesSupport}
                >
                  Contactar a Ventas
                </BoldButton>
              </SegmentButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SlideNairo;
